import Vue from 'vue'
import VueRouter from 'vue-router'
import Bind from '@/views/bind/index.vue';
import Practice from '@/views/practice/index.vue';
import Show from '@/views/show/index.vue';
Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/practice' },
  { path: '/bind', component: Bind },
  { path: '/practice', component: Practice },
  { path: '/show', component: Show }
]

const router = new VueRouter({
  routes
})

export default router
